var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1368_5620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.40542 5.80675V4.70122L10.7873 4.03717V2.93164H6.91797V4.03717L8.29988 4.70122V5.80675",
    stroke: "#585858",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60131 9.40049H2.49577L1.83173 7.74219H0.726196V12.1643H1.83173L2.49577 10.506H3.60131",
    stroke: "#585858",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2152 7.46395L13.5511 8.84586H12.722V6.59141C12.722 6.31032 12.4978 6.08203 12.222 6.08203H6.63877C6.50638 6.08203 6.37869 6.13593 6.285 6.23183L4.98323 7.74033H4.15408C3.8777 7.74033 3.60132 8.01671 3.60132 8.2931V11.6097C3.60132 11.8911 3.87825 12.1625 4.15408 12.1625H4.98323L6.28555 13.6718C6.37924 13.7671 6.50638 13.8208 6.63877 13.8208H10.1917C10.3241 13.8208 10.4512 13.7671 10.5449 13.6718L12.5752 11.6039C12.6694 11.5083 12.7217 11.3789 12.7217 11.2438V10.5042H13.5508L14.2149 11.8861H15.2299V7.46395H14.2152Z",
    stroke: "#585858",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95804 9.67591L7.74698 12.7161L8.57613 10.2287H7.19421L8.57613 7.46484H9.95804L8.57613 9.67591H9.95804Z",
    fill: "#585858"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1368_5620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0561523 0.847656)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineIcon);
export default __webpack_public_path__ + "static/media/engineIcon.c932e7fd0749a5c0bf238967da5f3859.svg";
export { ForwardRef as ReactComponent };